import Component from '../component';

export default class ReferenceDownloads extends Component {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/reference-downloads/reference-downloads.js